module.exports = __webpack_public_path__ + "img/mh.8711b04d.svg";